/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Emailalreadyinuse3Inputs */

const en__field_emailalreadyinuse3 = /** @type {(inputs: _Field_Emailalreadyinuse3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This e-mail address is already in use. Please login or use an alterernative address.`)
};

const de__field_emailalreadyinuse3 = /** @type {(inputs: _Field_Emailalreadyinuse3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese E-Mail wird bereits verwendet. Bitte melden Sie sich an, oder verwenden Sie eine andere E-Mail Adresse.`)
};

/**
* | output |
* | --- |
* | "This e-mail address is already in use. Please login or use an alterernative address." |
*
* @param {_Field_Emailalreadyinuse3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_emailalreadyinuse3 = /** @type {((inputs?: _Field_Emailalreadyinuse3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Emailalreadyinuse3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_emailalreadyinuse3(inputs)
	return de__field_emailalreadyinuse3(inputs)
});
export { _field_emailalreadyinuse3 as "_field_emailAlreadyInUse" }